export function PartnerSignupHeader() {
  return (
    <div className="text-center mb-6">
      <h1 className="text-xl font-sans font-semibold text-gray-900 mb-2 text-center leading-none">
        Bem-vindo :)
      </h1>
      <p className="text-sm font-sans font-normal text-muted-foreground text-center leading-5">
        Estamos quase lá! Só precisamos de algumas
        <br />
        informações para ativar sua conta.
      </p>
    </div>
  );
}
